export default {
  String: 1,
  Money: 2,
  Percent: 3
}
